import React, { FC, MutableRefObject, useEffect, useRef, useState } from 'react';
import { CustomModal } from '@stereograph/storybook/dist/components/CustomModal/CustomModal';
import { MultiValue, OnChangeValue } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Form } from 'react-bootstrap';
import { Role } from '../../../interface/users';
import { userApi } from '../../../api/userApi';
import { rolesApi } from '../../../api/rolesApi';
import { Instance } from '../../../models/instance';
import { useParams } from 'react-router-dom';
import { tradEdition, tradToaster } from './UserKeyTranslation';
import toast from 'react-hot-toast';

interface UsersModalsProps {
  show: boolean;
  setShow: Function;
  setReloadData: Function;
  reloadData: boolean;
  originalInstance: Instance;
}

interface Option {
  readonly label: string;
  readonly value: string;
}

const options: Array<Option> = [];

const createOption = (label: string, value: string) => ({
  label,
  value
});

const UserEditionModal: FC<UsersModalsProps> = (props) => {
  const { show, setShow, setReloadData, reloadData, originalInstance } = props;
  const { tradToasterEmptyField, tradToasterSuccessCreate, tradToasterRolesCreate } = tradToaster();
  const {
    tradEditionName,
    tradEditionEmail,
    tradEditionRole,
    tradEditionSelect,
    tradEditionRoleCreate,
    tradEditionTitle,
    tradEditionCancel
  } = tradEdition();
  const [roles, setRoles] = useState<Array<Role>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [roleValues, setRoleValues] = useState<MultiValue<Option> | Option | null | undefined | Array<Option>>([]);
  const nameUserRef: MutableRefObject<HTMLInputElement | null> = useRef(null);
  const emailUserRef: MutableRefObject<HTMLInputElement | null> = useRef(null);
  const rolesUserRef: any = useRef(null);

  const { instanceId } = useParams();

  useEffect(() => {
    const fetchRoles = async () => {
      const result = await rolesApi.getAll(instanceId);
      setRoles(result);
    };
    fetchRoles();
  }, []);

  useEffect(() => {
    if (roles) {
      roles.forEach((role) => {
        if (options.find((option) => option.label === role.name)) {
          options.splice(0, options.length);
        }
        return options.push(createOption(role.name, role.id));
      });
    }
  }, [roles]);

  const handleChange = (newValue: OnChangeValue<Option, true>) => {
    setRoleValues(newValue);
  };

  const handleCreate = async (inputValue: string) => {
    setLoading(true);
    const result = await rolesApi.create(originalInstance.instanceId, inputValue);
    if (result.status === 200) {
      toast.success(tradToasterRolesCreate);
      const newOption = createOption(result.data.name, result.data.id);
      if (Array.isArray(roleValues)) {
        setRoleValues([...roleValues, newOption]);
      }
      setReloadData(!reloadData);
    }
    setLoading(false);
  };

  const handleEmailChange = (e) => {
    if (emailUserRef.current) {
      emailUserRef.current.value = e.target.value.trim();
    }
  };

  const submitForm = async () => {
    const nameValue = nameUserRef.current?.value;
    const emailValue = emailUserRef.current?.value;
    const trimmedEmailValue = emailValue && emailValue.trim();

    if (!nameValue || !trimmedEmailValue) {
      toast.error(tradToasterEmptyField);
      return;
    }
    if (rolesUserRef.current.props.value && nameUserRef.current?.value && emailUserRef.current?.value) {
      const arrayRole: Array<Role> = [];
      rolesUserRef.current.props.value.map((role) => {
        return arrayRole.push({
          id: role.value,
          name: role.label
        });
      });
      const result = await userApi.createUser(originalInstance.instanceId, {
        id: '',
        name: nameUserRef.current?.value,
        email: emailUserRef.current?.value,
        roles: arrayRole
      });
      if (result?.status === 200 || result?.status === 204) {
        toast.success(tradToasterSuccessCreate);
        setShow(false);
      }
      setReloadData(!reloadData);

      setRoleValues([]);
    }
  };

  return (
    <>
      <CustomModal
        show={show}
        setShow={setShow}
        onAction={() => submitForm()}
        actionName={'Validation'}
        title={tradEditionTitle}
        type={'primary'}
        cancelButton={tradEditionCancel}>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>{tradEditionName}</Form.Label>
            <Form.Control type="text" ref={nameUserRef}></Form.Control>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>{tradEditionEmail}</Form.Label>
            <Form.Control type="text" ref={emailUserRef} onChange={handleEmailChange}></Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>{tradEditionRole}</Form.Label>
            <CreatableSelect
              ref={(ref) => {
                rolesUserRef.current = ref;
              }}
              formatCreateLabel={(inputValue: string) => `${tradEditionRoleCreate} ${inputValue}`}
              placeholder={tradEditionSelect}
              onChange={handleChange}
              onCreateOption={handleCreate}
              options={options}
              isLoading={loading}
              isMulti={true}
              value={roleValues || undefined}
            />
          </Form.Group>
        </Form>
      </CustomModal>
    </>
  );
};

export default UserEditionModal;
